// Navbar.jsx – Luxury Wellness Edition (Mobile Fixed + Wow Factor)
import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { 
  FaHome, FaSpa, FaLeaf, FaCamera, FaUserMd, FaEnvelope, 
  FaCalendarCheck, FaTimes, FaBars 
} from 'react-icons/fa';
import './navbar.css';

const navItems = [
  { to: '/', label: 'Home', icon: FaHome, end: true },
  { to: '/treatments', label: 'Treatments', icon: FaSpa },
  { to: '/aboutus', label: 'About Us', icon: FaLeaf },
  { to: '/gallery', label: 'Gallery', icon: FaCamera },
  { to: '/doctors-profiles', label: 'Doctors', icon: FaUserMd },
  { to: '/contactus', label: 'Contact', icon: FaEnvelope },
];

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [isOpen]);

  const toggleMenu = () => setIsOpen(prev => !prev);
  const closeMenu = () => setIsOpen(false);

  return (
    <>
      <nav className={`navbar ${scrolled ? 'scrolled' : ''} ${isOpen ? 'menu-open' : ''}`}>
        <div className="nav-container">
          <div className="logo-wrapper">
            <img
              src="/logo - Elisians.png"
              alt="Elysians Wellness"
              className="logo"
              onClick={() => { closeMenu(); navigate('/'); }}
            />
          </div>

          <ul className="nav-menu desktop-menu">
            {navItems.map(item => (
              <li key={item.to}>
                <NavLink 
                  to={item.to} 
                  end={item.end}
                  onClick={closeMenu}
                  className={({ isActive }) => isActive ? 'active' : ''}
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>

          <button 
            className="book-btn desktop-book"
            onClick={() => { closeMenu(); navigate('/booking'); }}
          >
            <FaCalendarCheck /> Book Now
          </button>

          <button 
            className="menu-toggle"
            onClick={toggleMenu}
            aria-label={isOpen ? 'Close menu' : 'Open menu'}
            aria-expanded={isOpen}
          >
            {isOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </nav>

      {/* Premium Mobile Menu */}
      <div className={`mobile-menu ${isOpen ? 'active' : ''}`}>
        <div className="mobile-header">
          <img src="/logo - Elisians.png" alt="Elysians" className="mobile-logo" />
          <button onClick={closeMenu}><FaTimes /></button>
        </div>

        <ul className="mobile-nav-items">
          {navItems.map((item, idx) => (
            <li 
              key={item.to} 
              style={{ '--item-index': idx }}
              className="menu-item"
            >
              <NavLink 
                to={item.to} 
                end={item.end}
                onClick={closeMenu}
                className={({ isActive }) => isActive ? 'active' : ''}
              >
                <item.icon className="menu-icon" />
                <span>{item.label}</span>
              </NavLink>
            </li>
          ))}
        </ul>

        <div className="mobile-cta">
          <button onClick={() => { closeMenu(); navigate('/booking'); }}>
            <FaCalendarCheck /> Begin Your Journey
          </button>
        </div>
      </div>

      {isOpen && <div className="menu-overlay" onClick={closeMenu} />}
    </>
  );
};

export default Navbar;